/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { PluginKey as o } from "@progress/kendo-editor-common";
const e = new o("editor-props");
export {
  e as editorPropsKey
};
